<template>
  <div ref="spendBall" class="suspended-ball" :style="{width: width+'px', height: height+'px', right: right+'px', bottom: bottom+'px'}" @mousedown="down"
    @touchstart="down" @mousemove="move" @touchmove="move" @mouseup="end" @touchend="end">
    <slot>悬浮</slot>
  </div>
</template>

<script>
export default {
  name: "SuspendedBall",
  props: {
    // 通过position来设置初始定位
    width: {
      type: Number,
      default: 50
    },
    height: {
      type: Number,
      default: 50
    },
    right: {
      type: Number,
      default: 34
    },
    bottom: {
      type: Number,
      default: 70
    },
    // 通过fixed来禁用自由移动
    fixed: {
      type: Boolean,
      default: false
    },
    limtBot: {
      type: Number,
      default: 60,
    }
  },
  data() {
    return {
      flags: false,
      positionTemp: { x: 0, y: 0 },   // 记录手指点击的位置
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      xPum: '',
      yPum: '',
    }
  },
  methods: {
    down(event) {
      if (this.fixed) {
        return
      }
      this.flags = true;
      let touch;
      // 该if判断是用touch还是mouse来移动
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.positionTemp.x = touch.clientX;   // 手指点击后的位置
      this.positionTemp.y = touch.clientY;
      let spendBall = this.$refs.spendBall;
      this.dx = spendBall.offsetLeft;    // 移动的div元素的位置
      this.dy = spendBall.offsetTop;
    },
    move(event) {
      if (this.flags) {
        let touch;
        // 该if判断是用touch还是mouse来移动
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }

        this.nx = touch.clientX - this.positionTemp.x; // 手指移动的变化量
        this.ny = touch.clientY - this.positionTemp.y;
        this.xPum = this.dx + this.nx; // 移动后，div元素的位置
        this.yPum = this.dy + this.ny;
        // 页面的宽高
        let windowWidth = document.documentElement.clientWidth
        let windowHeight = document.documentElement.clientHeight
        // 最大边界值
        let maxLeft = this.xPum + this.width;
        let maxBottom = this.yPum + this.height + this.limtBot;
        let spendBall = this.$refs.spendBall;
        if (this.xPum > 0 && maxLeft < windowWidth) {
          spendBall.style.left = this.xPum + "px";
        } else if (this.xPum <= 0) {
          spendBall.style.left = 0 + "px";
        } else if (maxLeft >= windowWidth) {
          spendBall.style.left = windowWidth - this.width + 'px';
        }
        if (this.yPum > 0 && maxBottom < windowHeight) {
          spendBall.style.top = this.yPum + "px";
        } else if (this.yPum <= 0) {
          spendBall.style.top = 0 + "px"
        } else if (maxBottom >= windowHeight) {
          spendBall.style.top = windowHeight - this.height - this.limtBot + "px";
        }

        document.addEventListener("touchmove", this.preventDefault, { passive: false })
        document.addEventListener("mousemove", this.preventDefault, { passive: false })
      }
    },
    //鼠标释放时候的函数，鼠标释放，移除之前添加的侦听事件，将passive设置为true，不然背景会滑动不了
    end() {
      this.flags = false
      // 注意事项，在添加和删除监听事件时，其function必须是同名的函数，不能为匿名函数。
      document.removeEventListener('touchmove', this.preventDefault, false)
      document.removeEventListener('mousemove', this.preventDefault, false)
      // 下面两句是保证在移除监听事件后，除了悬浮球的部分还能够滑动，如果不添加，则无法滑动
      document.addEventListener("touchmove", function (e) {
        window.event.returnValue = true
      })
      document.addEventListener("mousemove", function (e) {
        window.event.returnValue = true
      })
    },
    preventDefault(e) {
      e.preventDefault()
    }
  },
}
</script>

<style lang="scss" scoped>
.suspended-ball {
  z-index: 999;
  position: fixed;
}
</style>

